import { Injectable, Inject } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { API_URL } from '../models/api-url.token';
import {
  IMyOskLectureAttendanceListDetailsVm,
  IMyOskLectureAttendanceListIm,
  IMyOskLectureAttendanceListUm,
} from '../my-osk-lecture-attendance-models.model';

/** One lecture day of a group: who confirmed in the app and the marks of the staff; DELETE only for an empty list. */
@Injectable({ providedIn: 'root' })
export class MyOskLectureAttendanceListService {
  private readonly baseUrl: string;

  constructor(private http: HttpClient, @Inject(API_URL) private apiUrl: string) {
    this.baseUrl = `${this.apiUrl}/MyOskLectureAttendanceList`;
  }

  get(guid: string): Observable<IMyOskLectureAttendanceListDetailsVm> {
    const headers = this.createHeaders();
    let params = new HttpParams();
    if (guid !== undefined && guid !== null) {
      params = params.set('guid', String(guid));
    }
    return this.http.get<IMyOskLectureAttendanceListDetailsVm>(this.baseUrl, { headers, params });
  }

  post(myOskLectureAttendanceListIm: IMyOskLectureAttendanceListIm): Observable<IMyOskLectureAttendanceListDetailsVm> {
    const headers = this.createHeaders();
    return this.http.post<IMyOskLectureAttendanceListDetailsVm>(this.baseUrl, myOskLectureAttendanceListIm, { headers });
  }

  put(myOskLectureAttendanceListUm: IMyOskLectureAttendanceListUm): Observable<IMyOskLectureAttendanceListDetailsVm> {
    const headers = this.createHeaders();
    return this.http.put<IMyOskLectureAttendanceListDetailsVm>(this.baseUrl, myOskLectureAttendanceListUm, { headers });
  }

  delete(guid: string): Observable<boolean> {
    const headers = this.createHeaders();
    let params = new HttpParams();
    if (guid !== undefined && guid !== null) {
      params = params.set('guid', String(guid));
    }
    return this.http.delete<boolean>(this.baseUrl, { headers, params });
  }

  private createHeaders(): HttpHeaders {
    let headers = new HttpHeaders();
    const token = localStorage.getItem('authToken');
    if (token) headers = headers.set('Authorization', `Bearer ${token}`);
    return headers;
  }
}
